export default "__VITE_ASSET__51079457__"